export function makeContinuousEaseOut(
  t1: number, // длительность фазы 1 (ms)
  delta1: number, // угол фазы 1 (deg)
  t2: number, // длительность фазы 2 (ms)
  delta2: number, // угол фазы 2 (deg)
) {
  if (delta1 <= 0 || t1 <= 0 || delta2 <= 0 || t2 <= 0) {
    return "cubic-bezier(.42,.42,.2,1)";
  }
  const v1 = delta1 / t1; // угл. скорость фазы 1
  const v2 = delta2 / t2; // "стартовая" скорость фазы 2 (условная)
  const R = v1 / v2;

  const clamp = (x: number, lo: number, hi: number) =>
    Math.max(lo, Math.min(hi, x));
  const Rc = clamp(R, 0.2, 3);

  let x1: number;
  let y1: number;
  if (Rc > 1) {
    y1 = 1;
    x1 = 1 / Rc;
  } else {
    x1 = 0.5;
    y1 = 0.5 * Rc;
  }
  x1 = clamp(x1, 0.05, 0.9);
  y1 = clamp(y1, 0.05, 0.95);

  const x2 = clamp(x1 + 0.15, 0.45, 0.95);
  const y2 = 1;

  return `cubic-bezier(${x1.toFixed(3)},${y1.toFixed(3)},${x2.toFixed(3)},${y2.toFixed(3)})`;
}
